import Dialog from "../Dialog";
import { Button } from "../buttons/Button";
import { buttonsWrapper } from "./confirmDialog.css";

interface ConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  label: string;
  header: string;
  confirmButtonText: string;
  cancelButtonText: string;
  message?: string;
}

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  label,
  header,
  message,
  confirmButtonText,
  cancelButtonText,
}: ConfirmDialogProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Dialog isOpen={isOpen} handleClose={onCancel} label={label}>
      <h4>{header}</h4>
      {message && <p>{message}</p>}
      <div className={buttonsWrapper}>
        <Button fullWidth appearance="error" onPress={onConfirm}>
          {confirmButtonText}
        </Button>
        <Button fullWidth appearance="outlined" onPress={onCancel}>
          {cancelButtonText}
        </Button>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
